import { render } from "./PaymentChoice.vue?vue&type=template&id=4e307d05&scoped=true"
import script from "./PaymentChoice.vue?vue&type=script&lang=js"
export * from "./PaymentChoice.vue?vue&type=script&lang=js"

import "./PaymentChoice.vue?vue&type=style&index=0&id=4e307d05&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e307d05"]])

export default __exports__